import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Switch } from "@/components/ui/switch";
import { Field } from "@/components/common";
import { CoordinatePicker } from "@/components/MemberMap";

export default function PengaturanAbsensiPage() {
  const [f, setF] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/office/attendance").then((r) => setF({ lat: r.data.office_lat, lng: r.data.office_lng, radius_m: String(r.data.radius_m), radius_enabled: r.data.radius_enabled })).catch((e) => toast.error(errMsg(e))); }, []);
  const save = async () => {
    setBusy(true);
    try {
      await api.put("/office/attendance", { lat: f.lat ?? null, lng: f.lng ?? null, radius_m: Number(f.radius_m) || 100, radius_enabled: f.radius_enabled });
      toast.success("Pengaturan absensi disimpan");
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  if (!f) return <p className="text-muted-foreground">Memuat...</p>;
  return (
    <div className="max-w-2xl">
      <h1 className="font-heading text-2xl sm:text-3xl font-bold mb-5">Pengaturan Absensi</h1>
      <div className="panel space-y-5" data-testid="attendance-settings">
        <Field label="Titik Koordinat Kantor"><CoordinatePicker lat={f.lat} lng={f.lng} onChange={(c) => setF((x) => ({ ...x, ...c }))} /></Field>
        <Field label="Radius Absensi (meter)"><Input inputMode="numeric" className="h-11 max-w-[200px]" value={f.radius_m} onChange={(e) => setF({ ...f, radius_m: e.target.value.replace(/\D/g, "") })} data-testid="attendance-radius-input" /></Field>
        <label className="flex items-center justify-between rounded-2xl border p-4">
          <span><span className="block font-medium">Kunci radius absensi</span><span className="block text-xs text-muted-foreground">Semua pegawai kantor cabang (kepala cabang, kepala bagian, kasir, petugas lapangan) hanya bisa absen di dalam radius kantor</span></span>
          <Switch checked={f.radius_enabled} onCheckedChange={(v) => setF({ ...f, radius_enabled: v })} data-testid="attendance-radius-toggle" />
        </label>
        <Button className="h-11 rounded-full px-6" onClick={save} disabled={busy} data-testid="attendance-settings-save">{busy ? "Menyimpan..." : "Simpan"}</Button>
      </div>
    </div>
  );
}
